import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../lib/api";
import { Brand } from "../components/Brand";

// Landing page for the short code printed on a duck's underside: /q/<8 hex> (upper case on the duck, case-insensitive
// here). The backend resolves it — approved, non-deleted ducks only, and only to one of our own public origins.
export default function QrLandingPage() {
  const short = window.location.pathname.split("/").filter(Boolean).pop();
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(`${API}/q/${encodeURIComponent(short || "")}/target`)
      .then(({ data }) => {
        if (data?.url) window.location.replace(data.url);
        else setError("That code does not match a duck.");
      })
      .catch(() => setError("That code does not match a duck — check the eight characters printed under it."));
  }, [short]);

  return (
    <div data-testid="qr-landing-page" className="min-h-screen bg-dots grid place-items-center px-6 text-center">
      <div className="max-w-md">
        <Brand />
        <h1 className="font-heading text-2xl font-bold mt-6">{error ? "Code not found" : "Finding your duck…"}</h1>
        <p data-testid="qr-landing-message" className="text-muted-foreground mt-3">
          {error || "One moment — taking you to this duck's page."}
        </p>
      </div>
    </div>
  );
}
